module.exports = __webpack_public_path__ + "static/img/stuck_out_tongue_winking_eye.f71e53c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/stuck_out_tongue_winking_eye.png
// module id = oSu3
// module chunks = 0